module.exports = __webpack_public_path__ + "static/media/preview-icon.c299cb9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview-icon.svg
// module id = ./src/assets/images/preview-icon.svg
// module chunks = 0